import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found-container">
            <h1>We're Sorry, but you have reached a page that does not exist!</h1>
            <p>
                Please enter a new search query or click on the VIZEdi logo to go Home or click on any of the links to go to a different page.
            </p>
        </div>
    );
};

export default NotFound;
